/**
 * NOLAS 2026, (c) Mikaël FOURNY.
 * src/i18n/fr.exportDossier.ts
 *
 * Messages de l'écran « Dossier exposants et animateurs »
 * (/admin/export-dossier). Fusionné dans fr.ts. Un seul bloc, dans un
 * fichier dédié, pour ne rien mélanger aux autres chantiers.
 *
 * Mikael - chef de projet - 2026-09-30
 */
export const messagesExportDossierFr: Record<string, string> = {
  'adminNav.exportDossier': 'Dossier exposants et animateurs',
  'acces.titre.adminExportDossier': 'Dossier exposants et animateurs',

  'exportDossier.titre': 'Dossier exposants et animateurs',
  'exportDossier.sousTitre':
    'Une archive ZIP avec tous les exposants et tous les animateurs, un dossier pour chacun : logo, fiche imprimable, contacts, réseaux, une offre ou {lexWorkshopIndef} par fichier. Uniquement des fichiers courants (PDF, Excel, texte, images) : pratique pour transmettre le dossier complet à un partenaire.',
  'exportDossier.verification': 'Vérification de vos droits…',
  'exportDossier.sansDroit':
    'Vous n’avez pas le droit « Dossier exposants et animateurs ». Il s’accorde dans Contrôle d’accès, par rôle ou par compte.',
  'exportDossier.chargement': 'Lecture des exposants et des animateurs…',
  'exportDossier.erreur.resume': 'Impossible de lire le contenu du dossier. Réessayez dans un instant.',
  'exportDossier.erreur.generique':
    'La génération du dossier a échoué. Réessayez dans un instant ; si le problème persiste, prévenez l’administrateur du site.',

  'exportDossier.stat.exposants': 'Exposants',
  'exportDossier.stat.offres': 'Offres d’emploi',
  'exportDossier.stat.animateurs': 'Animateurs',
  'exportDossier.stat.ateliers': '{lexWorkshopPluralCap}',
  'exportDossier.logos':
    'Logos d’exposants fournis : {logos} sur {exposants}. Animateurs avec logo ou photo : {visuels} sur {animateurs}. La colonne « Logo » de index.xlsx indique qui en a fourni un.',
  'exportDossier.coordonnees.oui': 'Les coordonnées personnelles (courriels, téléphones) seront incluses.',
  'exportDossier.coordonnees.non':
    'Les coordonnées personnelles (courriels, téléphones) ne seront PAS incluses : il faut pour cela le droit « Fiche complète d’une personne ».',
  'exportDossier.degrade':
    'Certaines informations récentes (premium, recruteurs) ne sont pas encore disponibles sur ce serveur : elles manqueront au dossier.',

  'exportDossier.contenu.titre': 'Ce que contient l’archive',
  'exportDossier.contenu.index':
    'index.xlsx : un classeur Excel à deux feuilles, « Exposants » et « Animateurs », une ligne par dossier.',
  'exportDossier.contenu.exposants':
    'exposants/nom-de-l-entreprise/ : logo d’origine, fiche.pdf à imprimer, fiche.txt, contact.txt, reseaux.txt, offres.xlsx (toutes les offres) et un fichier .txt par offre.',
  'exportDossier.contenu.animateurs':
    'animateurs/nom-de-l-animateur/ : logo ou photo, fiche.pdf à imprimer, fiche.txt, contact.txt, un classeur Excel de tous ses {lexWorkshopPlural} et un fichier .txt par {lexWorkshopBare}.',
  'exportDossier.contenu.formats':
    'Les fichiers .txt s’ouvrent dans le Bloc-notes ou TextEdit, les .xlsx dans Excel, LibreOffice ou Numbers, les .pdf dans tout lecteur PDF.',

  'exportDossier.technique.libelle': 'Inclure aussi les fichiers techniques (.md et .json)',
  'exportDossier.technique.aide':
    'Réservé au super-administrateur. Ajoute, en plus des fichiers ci-dessus, le LISEZMOI.md, les fiches au format .md, les données brutes donnees.json et les index .csv.',

  'exportDossier.bouton': 'Générer et télécharger le ZIP',
  'exportDossier.bouton.enCours': 'Génération en cours…',
  'exportDossier.generation': 'Le dossier est en cours de préparation, cela peut prendre quelques secondes.',
  'exportDossier.fini': 'Dossier téléchargé : {fichier}',
  'exportDossier.journal':
    'Chaque export est inscrit au journal de l’organisation, à votre nom. Cinq exports au plus par quart d’heure.',
};
